import { z } from 'zod';

// Use a record type to match zod's inferred type of z.object({})
// This can be changed back into an interface if we add keys to SessionClientSettings
type SessionClientSettings = Record<string, never>;

const SessionClientSettings = z.object({});

export { SessionClientSettings };
